import _ from 'underscore';

angular.module('am4').directive('stickyFooter', function() {
    return {
        restrict: 'EA',
        template: require('./stickyFooter.html'),
        transclude: true,
        bindToController: {
            footerTemplate: '=stickyFooter',
            footerShow: '=',
            footerModClass: '@'
        },
        controller: function($scope, $window, $element, $timeout, $compile) {

            var that = this,
                initElBottomPadding = $element[0].style.paddingBottom,
                footerTemplate = $compile(that.footerTemplate)($scope);
            that.stickyFooterStatic = true;

            function setFooterVisibility() {
                var stickyFooterHeight = 0,
                    viewportHeight = $window.innerHeight,
                    stickyFooterContentEl = document.querySelector('.am4-sticky-footer .am4-sticky-footer__content'),
                    containerBottom,
                    newBottomPadding = 0;

                if (stickyFooterContentEl) {
                    stickyFooterHeight = stickyFooterContentEl.getBoundingClientRect().bottom - stickyFooterContentEl.getBoundingClientRect().top;
                }

                // Add padding to container equivalent to sticky footer height
                newBottomPadding = stickyFooterHeight;
                if (initElBottomPadding) {
                    newBottomPadding += parseInt(initElBottomPadding, 10);
                }
                $element[0].style.paddingBottom = newBottomPadding + 'px';

                containerBottom = $element[0].getBoundingClientRect().bottom;

                if (containerBottom - 1 <= viewportHeight) {
                    that.stickyFooterAtBottom = true;
                } else {
                    that.stickyFooterAtBottom = false;
                }

                that.stickyFooterStatic = false;

                $scope.$apply();

            }

            angular.element($window).bind('scroll', function() {
                setFooterVisibility();
            });

            angular.element($window).bind('resize', _.debounce(function() {
                setFooterVisibility();
            }, 250));

            $scope.$on('collapseEvent.animationDone', function() {
                $timeout(function() {
                    setFooterVisibility();
                });
            });

            $scope.$watch(function() {
                return that.footerShow;
            }, function(newVal, oldVal) {
                if (newVal === true && oldVal !== true) {
                    $timeout(function() {
                        setFooterVisibility();
                    }, 50);
                }
            });

            $timeout(function() {
                setFooterVisibility();
            });

            $element.find('.am4-sticky-footer__content__container').append(footerTemplate);
        },
        controllerAs: 'stickyFooterCtrl'
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/stickyFooter.js